import React, { useState } from 'react'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'
import { useStateValue } from '../state'
import { history } from './App'

export const OrderFilters = ({ coursenum, pageNum }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [currentState, dispatch] = useStateValue()

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleChange = (name, value) => {
    let filters = {
      ...currentState.filters,
      [name]: value,
    }
    dispatch({
      type: 'updateFilters',
      payload: filters,
    })
  }

  const clearFilters = () => {
    dispatch({
      type: 'updateFilters',
      payload: {
        createDateLowerBound: '',
        createDateUpperBound: '',
        emailFilter: '',
        statusFilter: '',
        institutionFilter: '',
      },
    })
    history.push(
      `/account/admin_coupons.management/${coursenum}/?page_num=${pageNum}`
    )
  }

  const applyFilters = async () => {
    setIsOpen(false)
    let params = new URLSearchParams()
    let filterKeys = Object.keys(currentState.filters)
    for (let i = 0; i < filterKeys.length; i++) {
      let key = filterKeys[i]
      if (currentState.filters[key] !== '') {
        params.append(key, currentState.filters[key])
      }
    }

    try {
      let resp = await client.post(
        endpoints.pageOrders({
          pageNum: pageNum,
          filterString: params.toString(),
        })
      )
      dispatch({
        type: 'updateOrderCount',
        payload: resp.data.totalOrderCount,
      })
      dispatch({
        type: 'updateOrders',
        payload: resp.data.orders,
      })
    } catch (err) {
      console.error(err)
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error while applying the filters. ${err}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-exclamation-triangle fa-3x" />}
          />
        ),
      })
    }
  }

  return (
    <div className={`dropdown ${isOpen ? 'show' : ''} cursor-auto`}>
      <div className=" d-flex flex-row-reverse">
        <button
          type="button"
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed dropdown-toggle"
          onClick={toggleDropdown}
        >
          <span className="far fa-filter mr-2"></span>
          Filter<span className="fas fa-caret-down ml-2"></span>
        </button>
      </div>
      <div
        className={`dropdown-menu ${isOpen ? 'show' : ''} pull-right p-3`}
        aria-labelledby="multiSelectDropdown"
        style={{ zIndex: 100000 }}
      >
        <div className="text-right">
          <button
            className="btn btn-default btn-myed btn-default-myed btn-sm-myed"
            onClick={toggleDropdown}
          >
            <span className="far fa-times mr-2"></span>
            Close
          </button>
        </div>
        <div className="d-flex">
          <label className="ml-3 w-100">
            Create date between:
            <div>
              <input
                type="date"
                name="createDateLowerBound"
                value={currentState.filters.createDateLowerBound}
                className="form-control pointer"
                onChange={evt =>
                  handleChange(evt.target.name, evt.target.value)
                }
              />
            </div>
            <div>
              and
              <input
                type="date"
                name="createDateUpperBound"
                value={currentState.filters.createDateUpperBound}
                className="form-control pointer"
                onChange={evt =>
                  handleChange(evt.target.name, evt.target.value)
                }
              />
            </div>
          </label>
        </div>
        <div className="p-3 w-100">
          <label className="mt-3 w-100">
            Email address contains:
            <div className="w-100">
              <input
                type="text"
                className="w-100"
                value={currentState.filters.emailFilter}
                name="emailFilter"
                onChange={evt =>
                  handleChange(evt.target.name, evt.target.value)
                }
              />
            </div>
          </label>
        </div>
        <form className="mt-3 p-3 w-100">
          <label htmlFor="invoice-status-select">Invoice Status</label>
          <select
            id="invoice-status-select"
            className="form-control w-100 pointer"
            value={currentState.filters.statusFilter}
            name="statusFilter"
            onChange={evt => handleChange(evt.target.name, evt.target.value)}
          >
            <option value="">Select a status</option>
            <option value="Outstanding">Outstanding</option>
            <option value="Paid">Paid</option>
            <option value="Voided">Voided</option>
          </select>
        </form>
        <div className="p-3 w-100">
          <label className="mt-3 w-100">
            Institution Contains:
            <div className="w-100">
              <input
                type="text"
                className="w-100"
                value={currentState.filters.institutionFilter}
                name="institutionFilter"
                onChange={evt =>
                  handleChange(evt.target.name, evt.target.value)
                }
              />
            </div>
          </label>
        </div>
        <div className="p-3 w-100">
          <label className="mt-3 w-100">
            Coupon Code (exact match):
            <div className="w-100">
              <input
                type="text"
                className="w-100"
                value={currentState.filters.couponCode}
                name="couponCodeFilter"
                onChange={evt =>
                  handleChange(evt.target.name, evt.target.value)
                }
              />
            </div>
          </label>
        </div>
        <div className="m-3">
          <button
            className="btn btn-success btn-myed btn-success-myed mr-3"
            onClick={applyFilters}
          >
            Apply Filters
          </button>
          <button
            className="btn btn-default btn-myed btn-default-myed"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  )
}
